//
//The module wraps up the basic CRUD operations to interact with the server
//The Url parameter should includes all the parameters required to retrieve data from the server
//and they can be added to relevant functions in the service layer
//
import Axios from 'axios'
const TIME_OUT = 30000;
export default {
    name: 'getRequest',

    //
    //Get data from server by GET method without authorization and parameters
    //
    async getData(url) {
        try {
            let response = await Axios.get(url, { timeout : TIME_OUT});
            return response.data;
        }
        catch (err) {
            throw err;
        }
        
    },

    //
    //Get data from server by GET method with token
    //
    async getDataWithToken(url, token) {
        try {

            let axios = Axios.create({
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            let response = await axios.get(url, { timeout : TIME_OUT});
            return response.data;
        }

        catch (err) {
            throw err;
        }
        
    },
}